// extracted by mini-css-extract-plugin
export default {"body":"authlayout_body__s5i3A","formcont":"authlayout_formcont__35+Wt"};